import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store'

// import App from '../App.vue';
import FeatureSelect from '../components/views/FeatureSelect.vue';
import Deposit from '../components/views/Deposit.vue';
import GiftCard from '../components/views/GiftCard.vue';
import Checkout from '../components/views/Checkout.vue';
import Confirmation from '../components/views/Confirmation.vue';
import Wechat from '../components/views/Wechat.vue';
import Stripe from '../components/views/Stripe.vue';
import CouponLottery from '../components/views/CouponLottery.vue';
import Migrate from '../components/views/Migrate.vue';
import WechatPay from '../components/views/WechatPay.vue';


Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/:storeId',
      name: 'Home',
      // component: App,
    },
    {
      path: '/fs/:storeId',
      name: 'FeatureSelect',
      component: FeatureSelect
    },
    {
      path: '/Deposit/:storeId',
      name: 'Deposit',
      component: Deposit,
    },
    {
      path: '/GiftCard/:storeId',
      name: 'GiftCard',
      component: GiftCard
    },
    // DEV-11246: Purchase Coupons is deprecated. Old links/bookmarks land on the store's
    // home, which routes to whatever features it still supports.
    {
      path: '/Coupon/:storeId',
      redirect: to => ({ name: 'Home', params: { storeId: to.params.storeId }, query: to.query })
    },
    {
      path: '/Checkout/:storeId',
      name: 'Checkout',
      component: Checkout
    },
    {
      path: '/Confirmation/:storeId',
      name: 'Confirmation',
      component: Confirmation
    },
    {
      path: '/Wechat/:storeId',
      name: 'Wechat',
      component: Wechat
    },
    {
      path: '/Wechat/:storeId/success_handler',
      name: 'Wechat',
      component: Wechat
    },
    {
      path: '/:groupid/:storeId/success_handler',
      name: 'Wechat',
      component: Wechat
    },
    {
      path: '/:storeId/3ds_success_handler',
      name: 'stripe-handler',
      component: Stripe
    },
    {
      path: '/f/lucky_wheel',
      name: 'CouponLottery',
      component: CouponLottery
    },
    {
      path: '/f/migrate/:storeId',
      name: 'Migrate',
      component: Migrate
    },
    {
      path: '/WechatPay/:storeId',
      name: 'WechatPay',
      component: WechatPay
    }
  ]
})

router.beforeEach((to, from, next) => {
  const features = [ 'GiftCard', 'Deposit']
  const newFeature = features.includes(to.name)

  // If the user arrived at a new feature in an unexpected way,
  // we need to update the selected method to return properly
  if (newFeature && to.name != store.state.feature)
    store.commit('setFeature', to.name)

  // Hold on to the returnUrl reference specifically when the route changes.
  // We don't want to store this in the state since it's only while using the specific link
  if (from.query.returnUrl && !to.query.returnUrl) {
    if (to.path === from.path) {
      // This is a no-no via the documentation, but a bug in routing to identical routes strips query params, and this prevents that
      return
    }

    next({
      path: to.path,
      query: {
        ...to.query,
        returnUrl: from.query.returnUrl,
        authorizationId: from.query.authorizationId
      }
    })
  }
  next()
})

export default router
